export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पंजीकरण विवरण"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["डेटा सहेजें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पुष्टि किया गया"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["यह फ़ील्ड सार्वजनिक है और अन्य उपयोगकर्ताओं को दिखाई देता है"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["यह फ़ील्ड अन्य उपयोगकर्ताओं से छिपा हुआ है"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पहचान सत्यापन"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सत्यापित"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रगति में"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सत्यापित नहीं"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सत्यापन शुरू करें"])}
}